import {CULTURA, FROTA, MOBILIDADE, NATAL} from '../../constants/products';
import {CIELO} from '../../constants/psrs';

const checkPsrCieloIsSelected = (psrsSelected) =>
  psrsSelected.indexOf(CIELO) >= 0;

const checkPsrProductHaveFrota = (productsSelected) =>
  productsSelected.indexOf(FROTA) >= 0;

const checkProductsRules = (groupProductsFromPsrSelected, psrsSelected) => {
  const havePsrCieloSelected = checkPsrCieloIsSelected(psrsSelected);
  const haveFrota = checkPsrProductHaveFrota(groupProductsFromPsrSelected);

  if (havePsrCieloSelected && psrsSelected.length === 1 && haveFrota) {
    groupProductsFromPsrSelected.push(MOBILIDADE);
  }

  groupProductsFromPsrSelected.push(CULTURA);
  groupProductsFromPsrSelected.push(NATAL);

  return groupProductsFromPsrSelected;
};

const concatenateProductGroup = (allProductsSelected) => {
  let groupProductsFromPsrSelected = [];
  for (const productsSelected of allProductsSelected) {
    groupProductsFromPsrSelected.push(...productsSelected);
  }
  return groupProductsFromPsrSelected;
};

const setGroupOfProductFromPsrsSelected = (psrsSelected, psrsWithProducts) => {
  const allProductsSelected = psrsWithProducts
    .filter((psrWithProducts) => psrsSelected.indexOf(psrWithProducts.psr) >= 0)
    .map((productsSelected) => {
      return productsSelected.products.map((product) => product.id);
    });

  const groupProductsFromPsrSelected =
    concatenateProductGroup(allProductsSelected);

  return checkProductsRules(groupProductsFromPsrSelected, psrsSelected);
};

const thisProductAllowedIsSelected = (
  productCode,
  groupProductsFromPsrSelected
) => {
  return groupProductsFromPsrSelected.indexOf(productCode) >= 0;
};

export const filterCommercialConditionsByProductsFromPsrsSelected = (
  commercialConditions,
  psrsSelected,
  psrsWithProducts
) => {
  const groupProductsFromPsrSelected = setGroupOfProductFromPsrsSelected(
    psrsSelected,
    psrsWithProducts
  );

  let newGroupCommercialConditions = [];
  for (const condition of commercialConditions) {
    if (
      thisProductAllowedIsSelected(
        Number.parseInt(condition.productCode, 10),
        groupProductsFromPsrSelected
      )
    ) {
      newGroupCommercialConditions.push(condition);
    }
  }

  return newGroupCommercialConditions;
};

export const filterProductMulti = (
  segregationTerms,
  newGroupComercialConditions
) => {
  if (!segregationTerms) {
    let newGroupCommercialConditionsWhitouTwoMulti = [];
    for (const comercialCodition of newGroupComercialConditions) {
      if (comercialCodition.company) {
        if (comercialCodition.company.documentNumber !== '09092759000116') {
          newGroupCommercialConditionsWhitouTwoMulti.push(comercialCodition);
        }
      } else {
        newGroupCommercialConditionsWhitouTwoMulti.push(comercialCodition);
      }
    }
    return newGroupCommercialConditionsWhitouTwoMulti;
  }

  return newGroupComercialConditions;
};
